import { Fragment } from "react";
import { CardBody, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { IoLocationOutline, IoPersonOutline } from "react-icons/io5";
import { useSettings } from "../../../../../../context/settings";
import { formatMoney, useCurrency } from "../../../../../../utils/helpers/currency";
import NotesSection from "../../../../components/Sections/Notes";
import AttachmentsSection from "../../../../components/Sections/Attachments";
import { Field, SectionCard } from "../../../../components/Record";
import { personName, printLeadStatus } from "../../../../utils/helpers";

function OverviewTab({ leadData }) {
  const { t } = useTranslation();
  const { formatDate } = useSettings();
  const baseCurrency = useCurrency();

  const currency = (leadData?.currency || baseCurrency || '').toUpperCase();
  const phone = [leadData?.country_code, leadData?.phone_number].filter(Boolean).join(' ');
  const whatsapp = [leadData?.whatsapp_country_code, leadData?.whatsapp].filter(Boolean).join(' ');

  return (
    <Fragment>
      <SectionCard
        id="lead-informations-card"
        icon={<IoPersonOutline size={15} />}
        title={t('crm.leadInformation')}
      >
        <CardBody>
          <Row className="g-3">
            <Field label={t('common.name')} value={leadData?.name} />
            <Field label={t('common.companyName')} value={leadData?.company_name} />
            <Field label={t('crm.leadOwner')} value={personName(leadData?.owner)} />
            <Field label={t('common.status')}>
              {printLeadStatus(leadData?.status) || <div className="crm-record-value">-</div>}
            </Field>
            <Field label={t('common.type')} value={leadData?.type ? t('crm.' + leadData.type) : null} />
            <Field label={t('crm.source')} value={leadData?.source} />
            <Field label={t('common.email')} value={leadData?.email} href={`mailto:${leadData?.email}`} />
            <Field label={t('common.phone')} value={phone} href={`tel:${leadData?.phone_number}`} />
            <Field label={t('profile.whatsapp')} value={whatsapp} />
            <Field
              label={t('settings.website')}
              value={leadData?.website}
              href={leadData?.website?.startsWith('http') ? leadData.website : `https://${leadData?.website}`}
            />
            <Field
              label={t('crm.expectedValue')}
              value={leadData?.expected_value ? `${formatMoney(leadData.expected_value)} ${currency}` : null}
            />
            <Field
              label={t('crm.probability')}
              value={leadData?.probability ? `${leadData.probability}%` : null}
            />
            <Field
              label={t('crm.expectedCloseDate')}
              value={leadData?.expected_close_date ? formatDate(leadData.expected_close_date) : null}
            />
            <Field label={t('hr.gender')} value={leadData?.gender} />
            <Field label={t('timeline.createdBy')} value={personName(leadData?.created_by)} />
          </Row>
        </CardBody>
      </SectionCard>

      <SectionCard
        id="address-card"
        icon={<IoLocationOutline size={15} />}
        title={t('common.address')}
      >
        <CardBody>
          <Row className="g-3">
            <Field label={t('address.city')} value={leadData?.city} />
            <Field label={t('address.state')} value={leadData?.state} />
            <Field label={t('address.zipCode')} value={leadData?.zip_code} />
            <Field label={t('address.country')} value={leadData?.country} />
          </Row>
        </CardBody>
      </SectionCard>

      <NotesSection objectData={leadData} objectType="lead" />

      <AttachmentsSection objectData={leadData} objectType="lead" />
    </Fragment>
  );
}

export default OverviewTab;
